export const Disclaimer = ({visible}) => {
    return(
        <div id="disclaimer">
            <p>
                All measurements displayed are to the nearest 0.1m. For exact dimensions please visit the relevant product page.
            </p>
        </div>
    )
}